export default {
    home: "Home",
    welcome: "Welcome",
    calendar: "Calendar",
    information: "Information",
    dictionary: "Dictionary",
    search: "Search",
    searchTerm: "Please enter your search term",
    noSearchResults: "No search results",
    writeAnArticle: "Write an article",
    article: "Article",
    photo: "Image",
    publish: "Publish",
    photoAlbum: "Photo album",
    logout: "Logout",
    ubtzYouthAddress:"Administration of JVC “UBR”, st. Seoul-42, Bayangol district, Ulaanbaatar city, 210535, Mongolia",
    changeLanguage: "Change Language",
  };